var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-center mb-6 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "w-2/5 flex gap-5 justify-between mdmax:w-full mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari no order, nama pembeli"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])])]), _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex items-center tab shadow-border-b mdmax:overflow-x-auto"
  }, _vm._l(_vm.tabList, function (tab, index) {
    return _c('div', {
      key: 'tab-' + index,
      staticClass: "relative px-6 py-3 cursor-pointer text-center font-medium whitespace-nowrap",
      class: [tab.active ? 'active text-neutral-700' : 'text-neutral-500'],
      on: {
        "click": function click($event) {
          return _vm.selectTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.title) + " ")]);
  }), 0), _c('div', {}, _vm._l(_vm.filteredData, function (pickup) {
    return _c('div', {
      key: pickup.id
    }, [_c('PickupCard', {
      attrs: {
        "data": pickup
      }
    })], 1);
  }), 0)]), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }